import { render } from "./Mb013.vue?vue&type=template&id=518e4c30&scoped=true"
import script from "./Mb013.vue?vue&type=script&lang=js"
export * from "./Mb013.vue?vue&type=script&lang=js"

import "./Mb013.vue?vue&type=style&index=0&id=518e4c30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518e4c30"]])

export default __exports__